var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.553,
    height: 19.547,
    viewBox: "0 0 30.553 19.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mastercardA{fill:#fff;}.mastercardB{fill:#ff5f00;}.mastercardC{fill:#eb001b;}.mastercardD{fill:#f79e1b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "mastercardA",
    width: 30.553,
    height: 19.547,
    rx: 1,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.033 0.746)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "mastercardB",
    width: 8.323,
    height: 13.628,
    transform: "translate(9.894 1.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mastercardC",
    d: "M103.22,30.152a8.658,8.658,0,0,1,3.3-6.814,8.671,8.671,0,1,0,0,13.628A8.824,8.824,0,0,1,103.22,30.152Z",
    transform: "translate(-92.488 -21.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mastercardD",
    d: "M141.168,46.335v-.279h.112V46H141v.056h.112l.056.279Zm.559,0V46h-.112l-.112.223L141.391,46h-.112v.335h.056v-.279l.112.223h.056l.112-.223v.279Z",
    transform: "translate(-113.901 -32.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mastercardD",
    d: "M131.621,30.152a8.63,8.63,0,0,1-8.658,8.657,8.779,8.779,0,0,1-5.363-1.843,8.686,8.686,0,0,0,1.452-12.176,8.929,8.929,0,0,0-1.452-1.452,8.7,8.7,0,0,1,12.177,1.452,8.441,8.441,0,0,1,1.843,5.362Z",
    transform: "translate(-103.573 -21.488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.3ba70a4ff9d0d607466d4270e0b3db86.svg";
export { ForwardRef as ReactComponent };